module.exports = __webpack_public_path__ + "img/suspensionPoint3.43a75a54.png";